import { render } from "./ManualPaymentModal.vue?vue&type=template&id=f63a33a6"
import script from "./ManualPaymentModal.vue?vue&type=script&lang=js"
export * from "./ManualPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__